import React, { useContext, useEffect, useState } from 'react';
import { ChevronDown, ChevronUp, Clock } from 'react-feather'; // Icons for toggle
import { languages } from '../../../Data/languages';
import NewButton from '../../../NewComponents/NewButton';
import { checkNotUndefinedValue, formatTotal, getDiscount, getDue, getExpedited, getHardCopyPrice, getOrderPageCountTotal, getTotal } from '../../../Data/Functions';
import { PayPalButtons } from '@paypal/react-paypal-js';
import "./OrderSummary.css"; // Ensure styles are added for smooth animation
import { DataContext } from '../../../Context/DataContext';
import { firestore } from '../../../firebase.config';

const OrderSummary = ({
  order,
  pagesCount,
  certified,
  languageFrom,
  languageTo,
  discount = 0,
  btnText = "",
  showBtn = false,
  handleBtnSubmit = () => {},
  disableBtn = false,
  onClickPaymentLink = () => {},
  sendPaymentLinkBtn = false,
  paypalBtn,
  createOrder,
  onApprove,
  onError,
  windowSize,
  totalWarning =false,
  isSupport = false,
  invoiceOrderSummary = false,
  setOpenModal = () => {},
  openModal = true,
  showTotal = true,
  showFreeOrdersLeft = false,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const { userData, teamData } = useContext(DataContext);

  useEffect(() => {
      setIsOpen(openModal);
  }, [openModal]);

  const getLanguage = (language) =>
    languages.find((lang) => lang.value === language)?.label || "";


  const getServicesTotal = () => {
    return (
      0 +
      (order.notarization ? 34.9 : 0) +
      (order.expeditedPlus || order.expedited
        ? getExpedited(order, pagesCount)
        : 0) +
      (order.hardCopy
        ? getHardCopyPrice(
            order.hardCopyExtra.country,
            order.hardCopyExtra.method,
            order.hardCopyExtra.requireSignature,
            order
          )
        : 0)
    );
  };

  const formatDiscount = (value) => "-$" + value.toFixed(2);

  const certifiedTranslationTotal = getOrderPageCountTotal(order, pagesCount, certified);
  const discountAmount = Math.max(getDiscount(order, pagesCount, discount, certified), 0);
  const finalTotal = Math.max(getTotal(order, pagesCount, certified) - getDiscount(order, pagesCount, discount, certified), 0);

  const checkOrderExists = () => {
    if(checkNotUndefinedValue(pagesCount)){
      if(pagesCount){
        return true
      }
    }
    if(order && order.pagesCount){
      if(order.pagesCount){
        return true
      }
    }
    return false
  }


  return (
    <>
      <div className={`${invoiceOrderSummary ? "invoiceOrderSummary" : "orderSummary"}`}>
       {!invoiceOrderSummary ? <div
          className={`orderSummaryHeader w-full`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h2 className={`orderSummaryTitle m-0`}>SUMMARY</h2>
          {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </div> : null}

        <div
          className={`orderSummaryContent w-full flex flex-col ${invoiceOrderSummary ? "gap-0" : "gap-2"} ${
            isOpen && checkOrderExists() ? "open" : "closed"
          }`}
        >
          <div className={`${invoiceOrderSummary ? "" : "orderSummaryInfoWrapper"} `}>
            <div className="orderSummaryInfo">
              <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>
                {certified ? "Certified Translation" : "Standard Translation"}
              </h4>
              <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>
                {pagesCount !== ""
                  ? formatTotal(certifiedTranslationTotal)
                  : "$0.00"}
              </h4>
            </div>
            <p className="orderSummaryInfoCount">
              {pagesCount !== ""
                ? `${pagesCount} pages (${
                    parseInt(pagesCount, 10) * 250
                  } words max)`
                : "0 pages (0 words max)"}
            </p>
            {languageFrom && languageTo && (
              <p className="orderSummaryInfoCount">
                {getLanguage(languageFrom)} to {getLanguage(languageTo)}
              </p>
            )}
          </div>

          {order.notarization ||
          order.expedited ||
          order.expeditedPlus ||
          (order.hardCopy &&
            order.hardCopyExtra.country !== "" &&
            order.hardCopyExtra.method !== "") ||
          (order.hardCopy && order.hardCopyExtra.requireSignature) ? (
            <div className={`${invoiceOrderSummary ? "" : "orderSummaryInfoWrapper"} `}>
                
              <div className="orderSummaryInfo">
                <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>Services
                {showFreeOrdersLeft && teamData && teamData.freeExpeditedOrders && teamData.freeExpeditedOrders > 0  
                 && order.teamId === teamData.id ? <span className={`orderSummaryInfoCount font-[600]`}> {"(" + teamData.freeExpeditedOrders + " free Orders Left)"}</span> : null}
                </h4>
                <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>{isSupport ?  "$***" : formatTotal(getServicesTotal())}</h4>
              </div>
              {order.notarization && <div className="orderSummaryInfo"><p className="orderSummaryInfoCount">Notarization</p><p className="orderSummaryInfoCount">$34.90</p></div>}
              {(order.expeditedPlus || order.expedited) && <div className="orderSummaryInfo"><p className="orderSummaryInfoCount">{order.expeditedPlus ? "Expedited+" : "Expedited"} Turnaround</p><p className="orderSummaryInfoCount">{formatTotal(getExpedited(order, pagesCount, false, false, certified))}</p></div>}
              {order.hardCopy && order.hardCopyExtra.country !== '' && order.hardCopyExtra.method !== '' && <div className="orderSummaryInfo"><p className="orderSummaryInfoCount">Mail Hard Copy</p><p className="orderSummaryInfoCount">{`$${['United States', 'Puerto Rico', 'U.S. Virgin Islands'].includes(order.hardCopyExtra.country) ? (order.hardCopyExtra.method === 'priority' ? '19.95' : '37.95') : (order.hardCopyExtra.method === 'priority' ? '49.95' : '78.95')}`}</p></div>}
              {order.hardCopy && order.hardCopyExtra.requireSignature && <div className="orderSummaryInfo"><p className="orderSummaryInfoCount">Signature Required for Delivery</p><p className="orderSummaryInfoCount">$4.99</p></div>}
            </div>
          ) : null}

          {discount > 0 && (
            <div className={`${invoiceOrderSummary ? "" : "orderSummaryInfoWrapper"} `}>
              <div className="orderSummaryInfo">
                <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>Discount ({discount}%)</h4>
                <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>
                  {formatDiscount(discountAmount)}
                </h4>
              </div>
              {order.discountCode && <div className="orderSummaryInfo">
                <p className="orderSummaryInfoCount">
                  {`(code: ${order.discountCode})`}
                </p>
              </div>}
            </div>
          )}

         {showTotal && <div className={`${invoiceOrderSummary ? "pt-[4px] orderSummaryTotal" : "orderSummaryTotal"}`}>
            <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>Total</h4>
            <h4 className={`${invoiceOrderSummary ? "orderSummaryInfoCount font-bold" : "orderSummaryInfoType"}`}>{isSupport ?  "$***" : pagesCount !== "" ? formatTotal(finalTotal) : "$0.00"}</h4>
          </div>}
          {totalWarning && <div className="orderSummaryTotal">
            <h4 style={{color: "#FF0000"}}>Item total must be greater than $1</h4>
          </div>}

          <div style={{width: "100%", marginTop: "10px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "0.5rem"}}>
            {showBtn && finalTotal!==0 && <NewButton width="100%" text={btnText} onClick={handleBtnSubmit} disable={disableBtn} />}
            {paypalBtn && !disableBtn && finalTotal!==0 && <PayPalButtons style={{ layout: "vertical", height: windowSize.width > 1024 ? 40 : 35, width: "100%" }} className='w-full' createOrder={createOrder} onApprove={onApprove} onError={onError} />}
            {sendPaymentLinkBtn  && finalTotal!==0 && <NewButton width="100%" text={"Send Payment Link"} onClick={onClickPaymentLink} disable={false} back={true} icon={false} whiteBtn sendIcon />}
          </div>
        </div>
      </div>

    </>
  );
};

export default OrderSummary;
